// The design pins the sync-status tag to 105px. A table column that renders the tag has to be
// at least this wide, so it reads the number from here rather than repeating the literal.
export const IMPORTED_INVOICE_SYNC_STATUS_WIDTH = 105
